import { Paging } from "api/baseApiResponseModel/BaseApiResponseModel";
import { NotificationRequestModel } from "api/merchantRepository/notification/model/NotificationRequestModel";
import { NotificationResponseModel } from "api/merchantRepository/notification/model/NotificationResponseModel";
import { BaseViewModel } from "components/base/BaseViewModel";
import { BehaviorSubject } from "rxjs";
import { injectable } from "tsyringe";
import { ServiceRepo } from "utils/serviceRepo/ServiceRepo";

class NotificationInput implements Disposable {
  public fetchNoti = new BehaviorSubject<NotificationRequestModel>({});
  public loading = new BehaviorSubject<boolean>(false);

  [Symbol.dispose](): void {
    this.fetchNoti.complete();
    this.loading.complete();
  }
}

class NotificationOutput implements Disposable {
  public savedNoti = new BehaviorSubject<Array<NotificationResponseModel>>([]);
  public pagination = new BehaviorSubject<Paging>({});

  [Symbol.dispose](): void {
    this.savedNoti.complete();
    this.pagination.complete();
  }
}

@injectable()
export class NotificationViewModel extends BaseViewModel<
  NotificationInput,
  NotificationOutput
> {
  constructor() {
    super(new NotificationInput(), new NotificationOutput());
  }
  private notiRepo = ServiceRepo.getNotificationRepo();

  protected override transform(): void {
    this.skipFirstInitial(this.input.fetchNoti, async (params) => {
      try {
        this.input.loading.next(true);
        const res = await this.notiRepo.getNoti(params);
        if (res?.data) {
          this.output.savedNoti.next(res?.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.input.loading.next(false);
      }
    });
  }
}
